// extracted by mini-css-extract-plugin
export default {"resultsTableContainer":"ResultsTable_resultsTableContainer__0Otpu","noResults":"ResultsTable_noResults__Pn5yG"};